import React, { PropTypes } from 'react';
import _ from 'lodash';
import 'moment-timezone';
import Card from "./bootstrap/Card";
import CardBlock from "./bootstrap/CardBlock";
import {byteToMegabyte} from "../helpers/helpers";

const AssignmentFileDownload = (props) => {

    let getAssignmentFile = function (filename) {
        const { assignment } = props,
            { assignment_files } = assignment
        ;

        if (assignment_files) {
            for (let i = 0, l = props.assignment.assignment_files.length; i < l; i++) {
                let assignment_file = props.assignment.assignment_files[i];
                if (assignment_file.name === filename) {
                    return assignment_file;
                }
            }
        }

        return undefined;
    };

    let assignment_filename = function (assignment_filename, i) {
        let file = getAssignmentFile(assignment_filename);
        return (
            <div id={"assignment_files" + i} className="uploaded-file mb-2" key={"file_" + assignment_filename}>
                {
                    file ? (
                        [file].map(assignment_file)
                    ) : (
                        null
                    )
                }
            </div>
        );
    };

    let assignment_file = function(assignment_file, i) {
        return (
            <div key={assignment_file.id} className={props.disabled ? 'disabled-overlay' : null}>
                <button
                    className="btn-link download-file"
                    key={assignment_file.id + "_download"}
                    id={assignment_file.id}
                    name={assignment_file.name}
                    size={assignment_file.size}
                    onClick={props.onDownloadFile}
                    disabled={props.disabled}
                >
                    <i
                        className="fa fa-download"
                        aria-hidden="true" id={assignment_file.id}
                        name={assignment_file.name}
                    /> {assignment_file.name}
                </button>
                <span> - {byteToMegabyte(assignment_file.size)}</span>
            </div>
        );
    };

    return (
        <Card>
            <CardBlock className="no-gutters">
                <b>{props.label}</b>
                <div className="col-sm-12">
                    {
                        _.map(
                            _.flatMap(
                                props.assignment.assignment_files,
                                assignment_file => {

                                    return assignment_file.name;
                                }
                            ),
                            assignment_filename
                        )
                    }
                </div>
            </CardBlock>
        </Card>
    );
};

AssignmentFileDownload.propTypes = {
    downloadOnly: PropTypes.bool,
    label: PropTypes.string.isRequired,
    assignment: PropTypes.object,
    onDownloadFile: PropTypes.func.isRequired,
    disabled: PropTypes.bool
};

export default AssignmentFileDownload;



/** WEBPACK FOOTER **
 ** ./src/components/AssignmentFileDownload.js
 **/